import { usePlatformUpdate } from '@reapitform/hooks'
import { IDocuments } from '@reapitform/dashboard-ui'

export interface SignAndCompleteAgreementPayload {
  iDs: string[]
}

export const useSignAndCompleteAgreement = () => {
  const path: string = '/api/User/Document/Complete'

  const [completeAgreement, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<
    SignAndCompleteAgreementPayload,
    IDocuments
  >({
    path: path,
    method: 'PATCH',
    headers: {},
    errorMessage: 'Failed to sign and complete the agreement',
    successMessage: 'Agreement successfully signed and completed',
  })

  return { completeAgreement, returnData, isLoading, isSuccess, isError }
}
